import { render, staticRenderFns } from "./FieldDeleteFile.vue?vue&type=template&id=ea1ed0ca&scoped=true"
import script from "./FieldDeleteFile.vue?vue&type=script&lang=js"
export * from "./FieldDeleteFile.vue?vue&type=script&lang=js"
import style0 from "./FieldDeleteFile.vue?vue&type=style&index=0&id=ea1ed0ca&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea1ed0ca",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Mobaxe\\Nevo.SimAdmin.Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ea1ed0ca')) {
      api.createRecord('ea1ed0ca', component.options)
    } else {
      api.reload('ea1ed0ca', component.options)
    }
    module.hot.accept("./FieldDeleteFile.vue?vue&type=template&id=ea1ed0ca&scoped=true", function () {
      api.rerender('ea1ed0ca', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Fields/FieldDeleteFile.vue"
export default component.exports